<template>
  <v-container fluid>
    <span>{{ $t('app.uploads.clickBelowToUpload') }}</span>

    <div class="profile-header">
      <div class="img-border">
        <div class="img-container">
          <Upload
            @fileSelect="handleFile"
            ref="fileInputProfile"
            hidden
            :label="$t('general.post.upload')"
          />

        <img
          v-if="!this.$store.getters.patient.profilePicture || !this.$store.getters.patient.profilePicture.blobUri"
          id="upload-image"
          class="profile-picture"
          src="@/assets/images/nophoto.png"
          :alt="
            `Profile picture of ${this.$store.getters.user.patient.firstName}`
          "
          @click="selectProfilePicture"
        />
        <!-- Auto rotate -->
        <auto-rotate v-else>
          <img
            id="upload-image"
            class="profile-picture"
            :src="this.$store.getters.patient.profilePicture.blobUri"
            :alt="
              `Profile picture of ${this.$store.getters.user.patient.firstName}`
            "
            @click="
              $store.getters.user.role === 'p' &&
                $modal.show('profile-pic-menu-modal')
            "
          />
        </auto-rotate>
          <p style="color:red" v-if="error">{{ error }}</p>

          <modal
            class="menu"
            name="profile-pic-menu-modal"
            width="100%"
            height="auto"
          >
            <ListItem
              border="1px solid #31b9be"
              @click.native="selectProfilePicture"
              >{{ $t("app.picture.edit") }}</ListItem
            >
            <ListItem
              border="1px solid #31b9be"
              last="true"
              @click.native="deleteProfilePicture"
              >{{ $t("app.picture.delete") }}</ListItem
            >
          </modal>
        </div>
        <span
          :style="
            `background-image: url(${require(`@/assets/icons/heart-pink.svg`)})`
          "
          class="mark"
        ></span>
      </div>
      <div class="diary-card-wrapper">
        <ProfileCard
          :title="$t('button.home')"
          link="/"
          icon="heart-pink"
        />
      </div>
    </div>
    <div class="profile-menu">
      <ProfileCard
        v-if="this.$store.getters.user.patients && this.$store.getters.user.patients.length > 1"
        :title="$t('app.dictionary.patient-selector')"
        link="/patientselector"
        icon="multiple-babies-pink"
      />
      <ProfileCard
        :title="$t('app.dictionary.title')"
        link="/profile/dictionary"
        icon="book-pink"
      />
      <ProfileCard
        v-if="this.$store.getters.user.role === 'p'"
        :title="$t('app.evolution.title')"
        link="/profile/evolution"
        icon="graph-pink"
      />
      <ProfileCard
        v-if="this.$store.getters.user.role === 'p'"
        :title="$t('app.milestone.title')"
        link="/profile/milestones"
        icon="flag-pink"
      />
      <ProfileCard
        :title="$t('app.gallery.title')"
        link="/profile/gallery"
        icon="camera-pink"
      />
      <ProfileCard
        :title="$t('app.temp-home.menu-title')"
        link="/hospital"
        icon="home-pink"
      />
      <ProfileCard
          v-if="canInvite"
        :title="$t('app.settings.general.invite')"
        link="/settings/access"
        icon="plus-pink"
      />
      <ProfileCard
        v-if="canHaveCode"
        :title="$t('app.settings.general.inviteCode')"
        link="/new-activation"
        icon="crib-pink"
      />
      <ProfileCard
        :title="$t('app.settings.title')"
        link="/settings"
        icon="settings-pink"
      />
    </div>
  </v-container>
</template>

<script>
import {neoparentUploads} from "@/api";
import axios from "@/services/mediligo-axios";

export default {
  name: "neoparent-menu",
  props: [],
  data() {
    return {
      error: null,
      canInvite: false,
      canHaveCode: false
    };
  },
  mounted() {
    this.canInvite =  !this.$store.getters.user.hospital.inviteByParentBlocked
    this.canHaveCode = this.$store.getters.user.hospital.inviteMethods && this.$store.getters.user.hospital.inviteMethods.includes('code')
  },

  methods: {
    selectProfilePicture() {
      if (this.$store.getters.user.role === "p") {
        this.$modal.hide("profile-pic-menu-modal");
        this.$refs.fileInputProfile.$el.click();
      }
    },
    async deleteProfilePicture() {
      await axios.post('/api/User/event/ProfilePictureRemoved');
      if (
        this.$store.getters.user.role === "p" &&
        confirm(this.$t("app.picture.confirm"))
      ) {
        this.$modal.hide("profile-pic-menu-modal");
        // try {
        //   const res = await axios.post(
        //     `${this.$backendRoot}/patients/${this.$session.get('patient').id}/update-photo`,
        //     {
        //       token: this.$session.get('token')
        //     }
        //   );
        //   const patient = res.data.patient;
        //   // Update session for profile pic etc
        //   this.$session.set('patient', patient);
        //   location.reload();
        // } catch (error) {
        //   this.consoleLog(error);
        //   this.error = error.response.data.message;
        // }
      }
    },
    async handleFile(files) {
      if (this.$store.getters.user.role === "p") {
        const file = files[0];
        file.access = "pub";

        const formData = new FormData()
        formData.append("file", file, file.name)
        formData.append("access", file.access)
        formData.append("mimeType", file.type)
        formData.append("patientId", this.$store.getters.patient.id)
        formData.append("isProfilePicture", true)

        const res = await neoparentUploads.uploadFile(formData)
        await axios.post('/api/User/event/ProfilePictureAdded');

        const patient = this.$store.getters.patient
        patient.profilePicture = res.data.data

        this.$store.commit("updatePatient", patient);

/*        try {
          const file = files[0];
          file.access = "pub";
          const endpoint = `${this.$backendRoot}/patients/${
            this.$session.get('patient').id
          }/update-photo`;
          const upload = await uploadFile(file, this.$session.get('token'));
          const uploadId = upload.data.data.id;
          const res = await axios.post(endpoint, {
            token: this.$session.get('token'),
            photoId: uploadId
          });
          const patient = res.data.patient;
          this.$session.set('patient', patient); // Update session for profile pic etc
          setImgPreview("upload-image", file);
        } catch (error) {
          this.consoleLog(error);
          this.error = error.response.data.message;
        }*/
      }
    }
  }
};
</script>

<style scoped lang="scss">
.loggedin-notice {
  color: #979797;
}

.img-border {
  width: 200px;
  background: #d9f0ea;
  border-radius: 5px;
  height: 200px;
  overflow: hidden;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.profile-header {
  width: 100%;
  max-width: 760px;
  margin: 24px auto 0;
  display: grid;
  grid-template-columns: repeat(2, 200px);
  gap: 14px;
  align-items: center;
  justify-content: center;
}

.diary-card-wrapper {
  width: 200px;
  max-width: 200px;
}

.img-container {
  overflow: hidden;
  border-radius: 50%;
  width: 75%;
  height: 75%;
  margin: auto;
}

.img-border img {
  width: 100%;
  height: 100%;
}

input {
  display: none;
}

label {
  cursor: pointer;
}

.mark {
  background-color: transparent;
  background-size: 100%;
  width: 56px;
  height: 56px;
  padding: 0;
  position: absolute;
  bottom: 0;
  right: 0;
}

.profile-menu {
  width: 100%;
  max-width: 760px;
  margin: 14px auto 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(145px, 1fr));
  gap: 14px;
  align-items: stretch;
  justify-items: stretch;
}

@media (max-width: 620px) {
  .profile-header {
    grid-template-columns: 1fr;
    justify-items: center;
  }

  .diary-card-wrapper {
    width: 200px;
    max-width: 200px;
  }
}

@media (min-width: 900px) {
  .profile-menu {
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 16px;
  }
}

.profile-picture {
  object-fit: cover;
}
</style>
